import React from 'react';
import "./searchbox.css";
import {Search} from "@mui/icons-material";

// The following functions do toggle visibility by changing the height of the list items.
// This is necessary to animate them (otherwise it would be easier to do it with CSS classes only)

const hideElement = (element) => {
    element.style.height = '0';
    element.classList.add('search-result-hidden');
}

const showElement = (element) => {
    const originalHeight = element.getAttribute('data-originalHeight')
    if(originalHeight) {
        element.style.height = originalHeight;
    } else {
        element.style.height = 'auto';
    }
    element.classList.remove('search-result-hidden');
}

const setOriginalHeightAttributeIfNotPresent = (element) => {
    if (!element.getAttribute('data-originalHeight')) {
        if (!element.style.height || element.style.height == 'auto') {
            const offsetHeight = element.offsetHeight;
            element.style.height = `${offsetHeight}px`;
        }
        element.setAttribute('data-originalHeight', element.style.height);
    }
}

const joinVisibleTextContent = (element) => {
    const visibleChildren = Array.from(element.querySelectorAll('.searchable'));
    return visibleChildren.map(child => child.textContent).join(' ');
}

const searchInDom = (text, startSearchAtCharacter) => {
    const searchText = (!text || text.length < startSearchAtCharacter) ? "" : text.toLowerCase();
    const elements = document.querySelectorAll('.list-item');
    [].forEach.call(elements, function(element) {
        setOriginalHeightAttributeIfNotPresent(element)
        const elementText = joinVisibleTextContent(element).toLowerCase()
        if(!searchText || (elementText && elementText.includes(searchText))) {
            showElement(element)
        } else {
            hideElement(element)
        }
    });
}

const defaultOnChangeEvent = (startSearchAtCharacter) => {
    return (event) => searchInDom(event.target.value, startSearchAtCharacter || 3)
}

export function SearchBox(props) {
    const {component, entity} = props
    const onchange = props.onchange || defaultOnChangeEvent(component.startSearchAtCharacter)

    return (
        <div className={"search-box"}>
            <input type={"text"} className={"search-box-input"} onInput={onchange} />
            <div className={"icon"}><Search fontSize={"large"} /></div>
        </div>
    );
}
